import React, { memo, useState, useEffect } from "react";
import { StyleSheet, Modal, View, Text, Pressable, TextInput, FlatList, Linking } from "react-native";
import { AntDesign } from "@expo/vector-icons";
import { CandidateProps } from "../types/candidate";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../services/connect";
import { colors } from "./Shared";
import CandidateCard from "./CandidateCard";

interface ModalCandidatePickerProps {
	visible: boolean;
	close: () => void;
	onSelect: (candidate: CandidateProps) => void;
}
const ModalCandidatePicker = ({ visible, close, onSelect }: ModalCandidatePickerProps) => {
	const [candidates, setCandidates] = useState<CandidateProps[]>([]);
	const [search, setSearch] = useState('');

	useEffect(() => {
		const ref = collection(db, 'candidates')
		onSnapshot(ref, (snap) => {
			if (snap.docs.length === 0) {
				return setCandidates([]);
			}

			const { docs } = snap;
			setCandidates(
				docs.map(doc => ({
					...doc.data(),
					id: doc.id
				} as CandidateProps))
			)
		});

	}, []);

	function filteredCandidates() {
		if (!search || search == '') {
			return candidates;
		}

		return candidates
			.filter(({ name, location, profession, recruitmentCompany }) =>
				name.toLowerCase().includes(search.toLowerCase()) ||
				location.toLowerCase().includes(search.toLowerCase()) ||
				profession.toLowerCase().includes(search.toLowerCase()) ||
				recruitmentCompany?.toLowerCase().includes(search.toLowerCase())
			);
	}

	return (
		<Modal
			visible={visible}
			animationType='fade'
			transparent
		>
			<View style={styles.backdrop}>
				<View style={styles.container}>
					<View style={styles.header}>
						<Text style={{ fontSize: 20 }}>Choose Candidate</Text>

						<Pressable onPress={close}>
							<AntDesign name="closecircleo" size={24} color="black" />
						</Pressable>
					</View>

					<TextInput
						style={{
							backgroundColor: colors.bg.medium,
							borderRadius: 10,
							padding: 10,
							width: '100%'
						}}
						onChangeText={setSearch}
						value={search}
						placeholder="Search"
					/>

					<FlatList
						data={filteredCandidates()}
						renderItem={({ item }) => (
							<CandidateCard
								id={item.id!}
								name={item.name}
								location={item.location}
								profession={item.profession}
								recruitmentCompany={item.recruitmentCompany || '-/-'}
								onPressDoc={() => Linking.openURL(item.resumeUrl)}
								onPress={() => onSelect(item)}
							/>
						)}
						columnWrapperStyle={{ justifyContent: 'space-between' }}
						style={{ marginTop: 40, marginRight: -20 }}
						numColumns={2}
						keyExtractor={({ id }) => 'candidate-' + id}
					/>
				</View>
			</View>
		</Modal>
	)
}

const styles = StyleSheet.create({
	backdrop: {
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
		backgroundColor: 'rgba(0, 0, 0, 0.5)'
	},
	container: {
		backgroundColor: '#fff',
		width: 600,
		borderRadius: 10,
		shadowColor: '#000',
		shadowOffset: {
			width: 0,
			height: 0
		},
		shadowOpacity: 0.1,
		shadowRadius: 40,
		padding: 20
	},
	header: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingBottom: 15,
		marginBottom: 15,
		borderBottomWidth: 1,
		borderColor: 'rgba(0, 0, 0, 0.5)'
	},
})

export default memo(ModalCandidatePicker);